const {setting} = require('./default')
module.exports = setting
